import React from 'react';
import {connect} from 'react-redux'
import {Saga} from './actions';
import * as selectors from './selectors';

const SearchField = ({searchTerm, updateSearchTerm, errorMessage}) => {

  searchTerm = !searchTerm ? "" : searchTerm;

  return (
    <form className="mt-3 container-fluid" onSubmit={e => { e.preventDefault(); }}>
      <div className="form-group required row ">
        <label htmlFor="searchTerm" className="search col-2">Search</label>
        <input id="searchTerm" name="searchTerm" className={"form-control col-10 " + (errorMessage && 'is-invalid')} type="text" value={searchTerm}
               onChange={evt => updateSearchTerm(evt.target.value)}/>
        {errorMessage &&
          <span className="invalid-feedback ">{errorMessage}</span>
        }
      </div>
    </form>
  );

}

const mapStateToProps = state => ({
  searchTerm: selectors.getSearchTerm(state),
  errorMessage: selectors.getSearchTermErrors(state)
});

const mapDispatchToProps = dispatch => ({
  updateSearchTerm : searchTerm => dispatch(Saga.setSearchTerm(searchTerm))
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchField);